module.exports = "/_next/static/images/4da4f051f13edc8dd4864b3a3fe4066a-two-people-looking-lg@3x.jpg";